class Token{
    constructor(){
        this.key="admin_lic_";
    }
    save = (k,value)=>{
        localStorage.setItem(this.key+k, value);
    }
    get=(k)=>{
        return localStorage.getItem(this.key+k);
    }
    
    setData=(data)=>{
        localStorage.setItem(this.key, JSON.stringify(data));
    }
    getData=()=>{
        if(localStorage.getItem(this.key)){
            var data = JSON.parse(localStorage.getItem(this.key));
            if(data.registro){
                return data;
            }else{
                return null;
            }
        }else{
            return null;
        }

    }
    clear=()=>{
        localStorage.removeItem(this.key);
        localStorage.clear();
    }
}
export default new Token();